import { ComponentType } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Feature, Position } from 'geojson';
import { take } from 'rxjs/operators';
import { MenuPopupComponent } from './menu-popup.component';

@Injectable({
  providedIn: 'root'
})
export class MenuPopupService {

  constructor(private dialog: MatDialog) {
  }

  open(config: MenuPopupConfig): void {
    const ref = this.getRef();
    if (ref) {
      ref.afterClosed()
        .pipe(take(1)).subscribe(() => {
          this.create(config);
        });
      this.close();
    } else {
      this.create(config);
    }
  }

  close() {
    const ref = this.getRef();
    if (ref) {
      ref.close();
    }
  }

  isOpened() {
    return !!this.getRef();
  }

  private create(config: MenuPopupConfig) {
    const dialogRef = this.dialog.open(MenuPopupComponent, { id: ID, data: config.data });
    dialogRef.componentInstance.component = config.component;
    const { top, left } = config;
    dialogRef.updatePosition({ top: `${top}px`, left: `${left}px` });
    return dialogRef.afterClosed();
  }

  private getRef() {
    return this.dialog.openDialogs.find((d) => d.id === ID);
  }
}

export interface MenuPopupConfig {
  top: number;
  left: number;
  component: ComponentType<any>;
  data: Position | Feature;
}

const ID = 'app-menu-popup-dialog';
